import { createUnifiedTheme, palettes, UnifiedTheme } from '@backstage/theme';
import { componentOverrides } from './componentOverrides';
import { brand, fonts, ThemeMode } from './tokens';

export function createTomTomTheme(mode: ThemeMode): UnifiedTheme {
  const t = brand[mode];

  return createUnifiedTheme({
    palette: {
      ...palettes[mode],
      navigation: {
        ...palettes[mode].navigation,
        background: t.sidebarBg,
        color: t.sidebarFg,
        selectedColor: t.sidebarFgSelected,
        indicator: t.accent,
        submenu: { background: t.submenuBg },
      },
    },
    fontFamily: fonts.body,
    components: componentOverrides(mode),
  });
}
